import React, {useEffect} from 'react';
import { observer, inject } from 'mobx-react';

import Constraint from 'js/components/Constraint';
import Backdrop from 'js/components/core/Backdrop';
import ProgressRow from 'js/components/core/SteppedPage/ProgressRow';
import ContinueButton from 'js/components/core/SteppedPage/ContinueButton';

import ProductDisplay from './ProductDisplayV2';
import Title from './Title';
import AddressInput from './AddressInput';
import Address2Input from './Address2Input';
import Button from './Button';
import ShippingSelector from './ShippingSelector';
import EstimateNote from './EstimateNote';
import analytics from "js/services/Analytics";
import SoldOutPage from "js/components-v2/pages/SoldOutPage/SoldOutPage";
import UserCountry from 'js/services/UserCountry';
import { formatCurrency } from 'js/services/Format';
import ToPay from './ToPay';
import {animated, Spring} from "react-spring";
import {AvForm} from "availity-mobx-reactstrap-validation";
import Label from "js/components/core/CopyItem/Label";
import Input from "js/components/core/CopyItem/Input";
import CopyIcon from "js/components/core/CopyItem/CopyIcon";
import ApplyCode from "js/components/pages/CheckoutPage/DropOffDetails/ApplyCode";
import {makeRequest, navigate, url} from "js/services/Network";
import {pick} from "lodash";
import AppUser from "js/stores/AppUser";
import {Link} from "@reach/router";
import AppContent from "js/components/AppContent";
import HappyHour from "js/components/pages/CheckoutPage/DropOffDetailsV2/HappyHour";
import {Modal} from "reactstrap";
import Form from "js/components/pages/BuyerSignupPage/DeliveryDetails/Form";

const offset = '3.25rem';
const altOffset = '0';

export default inject('page')(
  observer(({ page }) => {

    console.log("page: ",page);

    //country and bonus mismatch
    if (page.address?.country === 'NG' && (page.bonus_available === 500 || page.bonus_available === 5) && page.first_transaction === true){
      page.setBonusAvailable(500)
    } else if (page.address?.country === 'US' && (page.bonus_available === 500 || page.bonus_available === 5) && page.first_transaction === true){
      page.setBonusAvailable(5)
    }


    if (page.showShippingSelection && !page.shippingSelector.isLoading) {
      analytics.track('CTA_BP_checkout_item_dropoff_details_see_options', {
        'Source Address': '',
        'Destination Address': page.address,
        'Shipping Options': page.shippingSelector.options.toJSON(),
        'Shipping Cost': page.shippingSelector.value ? page.shippingSelector.value.price : '',
        'Item Price': page.item.price,
        'Item Name': page.item.title,
        'Item Size': page.item.size,
        'Payment Link': page.item.checkout_url,
        'Event Initiated by': 'buyer'
      })
    }

    if (page.sold_out) {
      return <SoldOutPage item={page.item} />;
    }

    const getPayAmount = () => {
      if (!page.shipping_service) return "[...calculating]";

      let bonus = 0;
      let subtractions = 0;
      if (page.address?.country === 'NG' && page.bonus_available >= 500)
        bonus = 500
      else if (page.address?.country === 'US' && page.bonus_available >= 5)
        bonus = 5;

      subtractions = page.happy_hour_status === 1 ? 0 : ((page.item.price >= page.discount_data_minimum_checkout_value && (page.discount_usages < page.discount_max_usage) ? page.discount_data_value:0) + bonus)

      return `${formatCurrency(page.item.price + (page.happy_hour_status === 1 ? 100 : page.shipping_service?.price)
        - subtractions,
        page.address?.country)}`;
    }
    let happyHourStatus = null;

    const verifyCode = async () => {

      try {
        const response = await makeRequest('get-discount-code-data', null, {'code':page.discount_code});
        page.setDiscountDataMessage(response.data.message);
        page.setDiscountDataAmount(response.data?.discount?.value);
        page.setDiscountDataMinimumCheckoutValue(response.data?.discount?.minimum_checkout_value);
        page.setDiscountUsages(response.data?.discount?.usages);
        page.setDiscountMaxUsage(response.data?.discount?.max_usage);

        if (window.app.env !== 'production') {
          console.log('discount message: ',page.discount_data_message)
          console.log('discount value: ',page.discount_data_value)
          console.log('item min value: ',page.discount_data_minimum_checkout_value)
        }

        analytics.track('CTA_BP_apply_discount_code', {
          'seller': page.item.seller.login,
          'Destination Address': page.address,
          'Shipping Options': page.shippingSelector.options.toJSON(),
          'Shipping Cost': page.shippingSelector.value ? page.shippingSelector.value.price : '',
          'Item Price': page.item.price,
          'Item Name': page.item.title,
          'Payment Link': page.item.checkout_url,
          'Event Initiated by': 'buyer'
        })

      } catch (error) {
        console.info(error);
        // setError(error.data
        //   ? error.data.message || error.data.statusText
        //   : 'Unknown error occurred');
      }
      analytics.track('CTA_coupon_code_active_users', {
        'Source Address': page.address,
        'Coupon Code': page.discount_code,
        'Coupon Value': page.discount_data_value,
        'Shipping Cost': page.shippingSelector.value ? page.shippingSelector.value.price : '',
        'Item Price': page.item.price,
        'Item Name': page.item.title,
        'Item Size': page.item.size,
        'Payment Link': page.item.checkout_url,
        'Event Initiated by': 'buyer'
      })
    }

    const setAddressInputFunc = () => {
      page.setAddressInput(!page.addressInput)
      if (window.app.env !== 'production') {
        console.log('Item: ',page.item, 'Page:',page, "country: ", page.address?.country)
      }
    }

    const happyHour = async () => {
      try {
        const response = await makeRequest('/happy-hour/status','',[])
        happyHourStatus = response.data;
      } catch (error) {
        console.info(error);
      }
    }

    // happyHour();

    const copyUrl = () => {
      navigator.clipboard.writeText(this.page.micro_store);
      this.setState({clicked: true});

      if(this.timerId) {
        clearTimeout(this.timerId);
      }

      setTimeout(() => {
        this.setState({clicked: false});
      }, 5000);
    };

    const redirect = (link,props,params) => navigate(url(link,props,params));

    const buttonCTA = (cta,link) => {
      redirect(link,{alias:this.state.alias},'');
    }

    function truncate(str) {
      return str.length > 23 ? str.substring(0, 20) + "..." : str;
    }

    const returnStep = <>

      <AppContent className="seller-items-page tw-bg-white" padded>
        <div className="pod-container tw-mt-8 tw-pr-5 tw-pl-5">
          <div className="tw-mt-12 tw-mb-8 tw-flex tw-items-center tw-justify-between">
            <Link className="tw-text-black tw-text-sm" to={`/seller/${page.item.seller.login}`}>
              <img
                src="/images/icons/icon-left.svg"
                alt="back"
                width="18" height="18"
              />&nbsp;&nbsp;&nbsp;&nbsp;
              <span className="tw-h-[18px] tw-text-sm tw-pt-[2px] tw-pb-[2px]">
                  Shop {page.item.seller.login?truncate(page.item.seller.login):'Someone\'s'} store home &nbsp;&nbsp;&nbsp;{'>>'} Cart &nbsp;&nbsp;&nbsp;{'>>'} <span style={{color:'#6D60F6', cursor:'pointer'}}>Checkout</span>
              </span>
            </Link>
            <button className="tw-bg-secondary tw-rounded-lg tw-border tw-border-white tw-py-2 tw-px-2 tw-text-white tw-flex-end md:tw-hidden"
                    onClick={(cta) => buttonCTA(cta,'/create-link')}>
              Become a seller &nbsp;
              <img
                src="/images/icons/right.svg"
                alt="shop"
                className="size-24px"
              />

            </button>
          </div>

          <div className="d-flex flex-column flex-md-row justify-content-between tw-gap-6">
            <div className="store-container md:tw-w-[75%] sm:tw-w-full md:tw-pr-20">
              <div className="md:tw-pl-5">
                <p className="tw-font-semibold tw-text-lg">Delivery address</p>
                <span className="tw-mb-5">
                  <span hidden={page.addressInput === false}>
                    <AddressInput
                      name="address"
                      showError={page.hasAddressError}
                      address={page.address}
                      onChange={page.addressSaved}
                      placeholder="Your street address"
                      flat={!page.showShippingSelection}
                      hidden={page.addressInput === false}
                      className="tw-w-full"
                    />
                  </span>
                  <div className="d-flex flex-column flex-md-row justify-content-between tw-mb-5">
                    <span className="tw-mb-5 float-start tw-font-normal tw-text-base">Saved address:&nbsp;{page.address.formatted_address}</span>
                    <span className="tw-mb-5 float-end tw-font-normal tw-text-base" style={{cursor:'pointer', color:'#6D60F6'}} onClick={setAddressInputFunc}>
                      <img
                        src="/images/icons/edit-2.svg"
                        alt="shop"
                        className="size-24px"
                      /> &nbsp;
                      {page.addressInput?'Set ':'Change '}address
                    </span>
                  </div>

                  <div className="tw-mb-5">
                    <p className="tw-font-semibold tw-text-lg">Select delivery type</p>
                    {page.happy_hour_status === 1 ? (
                      <>
                        <HappyHour start_date={page.happy_hour_start_time} start_hour={18} />
                      </>
                    ):(
                      <>
                        <div className="md:tw-w-[60%] tw-border-none">
                          <ShippingSelector
                            state={page.shippingSelector}
                            alias={page.alias}
                            destination={page.address}
                            onChange={page.setShippingService}
                          />
                          {page.shipping_service && <EstimateNote>* post-shipping estimations</EstimateNote>}
                        </div>
                      </>
                    )}
                  </div>

                  <div className="tw-mb-5 tw-mt-3">
                    <p className="tw-font-semibold tw-text-lg">Apply bonus: </p>
                    <span className="tw-text-base tw-pl-[10px]">
                      <span className="tw-font-normal tw-mb-3">Enter discount code</span>
                      {UserCountry === 'NG' || page.address.country === 'NG' && (
                        <>
                          <Spring
                            native
                            from={page.from || { opacity: 0, transform: 'translate3d(0,-2rem,0)' }}
                            to={page.to || { opacity: 1, transform: 'translate3d(0,0rem,0)' }}
                            config={page.config || { tension: 150 }}>
                            {animation => (
                              <animated.div style={animation}>
                                <AvForm>
                                  <Label className="d-flex tw-pl-4">
                                    <Input
                                      name="discountCode"
                                      type="text"
                                      placeholder="Enter discount code"
                                      value={page.discount_code}
                                      className="tw-w-[80%]"
                                      onChange={(evt) => { page.setDiscountCode(evt.target.value); }}
                                    />
                                    <button className="tw-bg-secondary tw-rounded-lg tw-border tw-border-white tw-text-white" onClick={verifyCode} type="submit">Apply code</button>
                                    {/*<ApplyCode onClick={verifyCode} type="submit" />*/}
                                  </Label>
                                </AvForm>
                              </animated.div>
                            )}
                          </Spring>
                          {page.discount_data_message ? (
                            <p style={{fontSize:'12px', textAlign:'end', marginRight:'8%'}}>{page.discount_data_message}</p>
                          ):''}
                          {/*<ToPay><strong>You will pay</strong> {getPayAmount()}</ToPay>*/}
                        </>
                      )}
                    </span>
                    <span className="tw-font-normal tw-mb-3 tw-hidden md:tw-block tw-mt-7 tw-mb-5" style={{fontSize:'15px'}}>Available bonuses & discounts (you can use 1 at a time)</span>

                    {page.address?.country === 'NG' && page.bonus_available >= 500 && (
                      <div className="d-flex flex-md-row tw-pl-[10px] tw-w-full">
                      <span className="float-start tw-w-[75%]">
                         <img
                           src="/images/icons/gift.png"
                           alt="shop"
                           className="size-24px"
                         />&nbsp;&nbsp;&nbsp;<span className="tw-font-semibold">{formatCurrency(500, page.currency)} Bonus</span>
                        <br/>
                        <span style={{fontSize:'13px', fontWeight:'lighter', lineHeight:'18px'}}>{page.first_transaction?'POD has given you this bonus for signing up. Earn more by referring your friends.':'POD has given you this bonus for referring a friend. Earn more by referring more friends.'}</span>
                      </span>
                        <span className="float-end">
                          {page.happy_hour_status !== 1 ? (
                            <>
                              <button className="tw-bg-white tw-rounded-lg tw-border tw-border-white tw-text-white tw-h-[100%]">
                                <span className="tw-text-secondary">Bonus applied &nbsp;</span>
                                <img
                                  src="/images/icons/tick-circle.png"
                                  alt="checked"
                                  className="tw-h-[16px] tw-w-[16px]"
                                />
                              </button>
                            </>
                          ) : (
                            <>
                              <button className="tw-bg-white tw-rounded-lg tw-border tw-border-white tw-text-white tw-h-[100%]">
                                <span className="tw-text-secondary">Bonus available &nbsp;</span>
                                <img
                                  src="/images/icons/tick-circle.png"
                                  alt="checked"
                                  className="tw-h-[16px] tw-w-[16px]"
                                />
                              </button>
                            </>
                          )}
                      </span>
                      </div>
                    )}

                    {page.address?.country === 'US' && page.bonus_available >= 5 && (
                      <div className="d-flex flex-md-row tw-pl-[10px] tw-w-full">
                      <span className="float-start tw-w-[75%]">
                         <img
                           src="/images/icons/gift.png"
                           alt="shop"
                           className="size-24px"
                         />&nbsp;&nbsp;&nbsp;<span className="tw-font-semibold">{formatCurrency(5, page.currency)} Bonus</span>
                        <br/>
                        <span style={{fontSize:'13px', fontWeight:'lighter', lineHeight:'18px'}}>POD has given you this bonus for referring a friend. Earn more by referring more friends</span>
                      </span>
                        <span className="float-end">
                          {page.happy_hour_status !== 1 ? (
                            <>
                              <button className="tw-bg-white tw-rounded-lg tw-border tw-border-white tw-text-white tw-h-[100%]">
                                <span className="tw-text-secondary">Bonus applied &nbsp;</span>
                                <img
                                  src="/images/icons/tick-circle.png"
                                  alt="checked"
                                  className="tw-h-[16px] tw-w-[16px]"
                                />
                              </button>
                            </>
                            ) : (
                              <>
                                <button className="tw-bg-white tw-rounded-lg tw-border tw-border-white tw-text-white tw-h-[100%]">
                                  <span className="tw-text-secondary">Bonus available &nbsp;</span>
                                  <img
                                    src="/images/icons/tick-circle.png"
                                    alt="checked"
                                    className="tw-h-[16px] tw-w-[16px]"
                                  />
                                </button>
                              </>
                          )}
                      </span>
                      </div>
                    )}

                    {page.bonus_available < 5 && (
                      <div className="d-flex flex-md-row tw-pl-[10px] tw-w-full">
                      <span className="float-start tw-w-[75%]">
                         <img
                           src="/images/icons/gift.png"
                           alt="shop"
                           className="size-24px"
                         />&nbsp;&nbsp;&nbsp;<span className="tw-font-semibold">{formatCurrency(0, page.currency)} Bonus</span>
                        <br/>
                        <span style={{fontSize:'13px', fontWeight:'lighter', lineHeight:'18px'}}>You have no bonus available at the moment, keep transacting to earn bonus</span>
                      </span>
                        <span className="float-end">
                        <button className="tw-bg-white tw-rounded-lg tw-border tw-border-white tw-text-white tw-h-[100%]">
                          <span className="tw-text-secondary">Bonus available &nbsp;</span>
                          <img
                            src="/images/icons/tick-circle.png"
                            alt="checked"
                            className="tw-h-[16px] tw-w-[16px]"
                          />
                        </button>
                      </span>
                      </div>
                    )}

                  </div>
                </span>
              </div>
            </div>
            <div className="added-item tw-hidden md:tw-block tw-w-[23%] tw-mt-1">
              <h2 className="tw-mb-2 tw-text-lg tw-font-semibold tw-text-gray-900 tw-dark:text-white">Order Summary and checkout</h2>
              <Backdrop offset={altOffset} style={{marginBottom: '0'}}>
                <Constraint style={{paddingLeft:'0', alignContent:'center'}}>
                  <ProductDisplay item={page.item} address={page.address} size={page.size} />
                </Constraint>
              </Backdrop>
              <div className="d-flex flex-column flex-md-row justify-content-between tw-mt-0 tw-mb-4">
                <div className="float-start">
                  <span className="font-weight-lighter" style={{lineHeight:'18px'}}>Item price:</span>
                </div>
                <div className="float-end">
                  <span className="font-weight-lighter" style={{lineHeight:'18px'}}>{formatCurrency(page.item.price, page.currency)}</span>
                </div>
              </div>

              { page.happy_hour_status !== 1 ? (
                  <>
                    {page.bonus_available >= 500 && page.address?.country === 'NG' && (
                      <div className="d-flex flex-column flex-md-row justify-content-between tw-mt-0 tw-mb-4">
                        <div className="float-start">
                          <span className="font-weight-lighter" style={{lineHeight:'18px'}}>Bonus:</span>
                        </div>
                        <div className="float-end">
                          <span className="font-weight-lighter" style={{lineHeight:'18px'}}> -{formatCurrency(500, page.currency)}</span>
                        </div>
                      </div>
                    )}

                    {page.bonus_available >= 5 && page.address?.country === 'US' && (
                      <div className="d-flex flex-column flex-md-row justify-content-between tw-mt-0 tw-mb-4">
                        <div className="float-start">
                          <span className="font-weight-lighter" style={{lineHeight:'18px'}}>Bonus:</span>
                        </div>
                        <div className="float-end">
                          <span className="font-weight-lighter" style={{lineHeight:'18px'}}> -{formatCurrency(5, page.currency)}</span>
                        </div>
                      </div>
                    )}

                    {page.discount_data_value > 0 && page.item.price >= page.discount_data_minimum_checkout_value && (page.discount_usages < page.discount_max_usage) && (
                      <div className="d-flex flex-md-row justify-content-between tw-mt-0 tw-mb-4">
                        <div className="float-start">
                          <span className="font-weight-lighter" style={{lineHeight:'18px'}}>Discount:</span>
                        </div>
                        <div className="float-end">
                          <span className="font-weight-lighter" style={{lineHeight:'18px'}}> -{formatCurrency(page.discount_data_value, page.currency)}</span>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <></>
              )}

              { page.shipping_service && (
                <div className="d-flex flex-column flex-md-row justify-content-between tw-mt-0 tw-mb-4">
                  <div className="float-start">
                    <span className="font-weight-lighter" style={{lineHeight:'18px'}}>Delivery fee:</span>
                  </div>
                  <div className="float-end">
                    <span className="font-weight-lighter" style={{lineHeight:'18px'}}> +{formatCurrency(page.happy_hour_status === 1 ? 100 : page.shipping_service?.price, page.currency)}</span>

                    {page.happy_hour_status === 1 && (
                      <><br/><span style={{fontStyle:'italic', fontSize:'10px', float:'inline-end',textDecoration:'line-through'}}>{formatCurrency(page.shipping_service?.price, page.currency)}</span></>
                    )}
                  </div>
                </div>
              )}

              <div className="d-flex flex-column flex-md-row justify-content-between tw-mt-0 tw-mb-4">
                <div className="float-start">
                  <span className="font-weight-bolder tw-font-semibold" style={{lineHeight:'28px', fontSize:'17px'}}>Total</span>
                </div>
                <div className="float-end">
                  <span className="font-weight-bolder tw-font-semibold" style={{lineHeight:'28px', fontSize:'17px', color:'#6D60F6'}}> {getPayAmount()}</span>
                </div>
              </div>
              <button className="tw-w-full tw-h-[45px] tw-bg-secondary tw-rounded-lg tw-border tw-border-white tw-text-white tw-mt-6"
                      onClick={page.nextStep} disabled={!page.shipping_service?.price}>
                Checkout
                {/*<img*/}
                {/*  src="/images/icons/right.svg"*/}
                {/*  alt="shop"*/}
                {/*  className="size-24px"*/}
                {/*/>*/}
              </button>
              {page.error && (
                <p className="tw-w-full text-center" style={{fontSize: '14px', color:'hotpink', fontWeight:'bold',}}>{page.error}</p>
              )}

            </div>
            <div className="added-item md:tw-hidden tw-mt-10">
              <h2 className="tw-mb-2 tw-text-lg tw-font-semibold tw-text-gray-900 tw-dark:text-white">Order Summary and checkout</h2>
              <Backdrop offset={altOffset} style={{marginBottom: '0'}}>
                <Constraint style={{paddingLeft:'0', alignContent:'center'}}>
                  <ProductDisplay item={page.item} address={page.address} size={page.size} />
                </Constraint>
              </Backdrop>
              <div className="d-flex flex-md-row flex-md-row justify-content-between tw-mt-0 tw-mb-4">
                <span className="float-start font-weight-lighter" style={{lineHeight:'18px'}}>Item price:</span>
                <span className="float-end font-weight-lighter" style={{lineHeight:'18px'}}>{formatCurrency(page.item.price, page.currency)}</span>
              </div>

              { page.happy_hour_status === 1 ? (
                <></>
              ) : (
                <>
                  {page.bonus_available >= 500 && page.address?.country === 'NG' && (
                    <div className="d-flex flex-md-row justify-content-between tw-mt-0 tw-mb-4">
                      <div className="float-start">
                        <span className="font-weight-lighter" style={{lineHeight:'18px'}}>Bonus:</span>
                      </div>
                      <div className="float-end">
                        <span className="font-weight-lighter" style={{lineHeight:'18px'}}> -{formatCurrency(500, page.currency)}</span>
                      </div>
                    </div>
                  )}

                  {page.bonus_available >= 5 && page.address?.country === 'US' && (
                    <div className="d-flex flex-md-row justify-content-between tw-mt-0 tw-mb-4">
                      <div className="float-start">
                        <span className="font-weight-lighter" style={{lineHeight:'18px'}}>Bonus:</span>
                      </div>
                      <div className="float-end">
                        <span className="font-weight-lighter" style={{lineHeight:'18px'}}> -{formatCurrency(5, page.currency)}</span>
                      </div>
                    </div>
                  )}

                  {page.discount_data_value > 0 && page.item.price >= page.discount_data_minimum_checkout_value && (page.discount_usages < page.discount_max_usage) && (
                    <div className="d-flex flex-md-row justify-content-between tw-mt-0 tw-mb-4">
                      <div className="float-start">
                        <span className="font-weight-lighter" style={{lineHeight:'18px'}}>Discount:</span>
                      </div>
                      <div className="float-end">
                        <span className="font-weight-lighter" style={{lineHeight:'18px'}}> -{formatCurrency(page.discount_data_value, page.currency)}</span>
                      </div>
                    </div>
                  )}
                </>
              )}




              { page.shipping_service && (
                <div className="d-flex flex-md-row justify-content-between tw-mt-0 tw-mb-4">
                  <div className="float-start">
                    <span className="font-weight-lighter" style={{lineHeight:'18px'}}>Delivery fee:</span>
                  </div>
                  <div className="float-end">
                    <span className="font-weight-lighter" style={{lineHeight:'18px'}}> +{formatCurrency(page.happy_hour_status === 1 ? 100 : page.shipping_service?.price, page.currency)}</span>

                    {(page.happy_hour_status === 1 || page.discount_data_value > 0) && (
                      <><br/><span style={{fontStyle:'italic', fontSize:'10px', float:'inline-end',textDecoration:'line-through'}}>{formatCurrency(page.shipping_service?.price, page.currency)}</span></>
                    )}
                  </div>
                </div>
              )}

              <div className="d-flex flex-md-row flex-md-row justify-content-between tw-mt-0 tw-mb-4">
                <div className="float-start">
                  <span className="font-weight-bolder tw-font-semibold" style={{lineHeight:'28px', fontSize:'17px'}}>Total</span>
                </div>
                <div className="float-end">
                  <span className="font-weight-bolder tw-font-semibold" style={{lineHeight:'28px', fontSize:'17px', color:'#6D60F6'}}> {getPayAmount()}</span>
                </div>
              </div>

              <button className="tw-w-full tw-h-[45px] tw-bg-secondary tw-rounded-lg tw-border tw-border-white tw-text-white"
                      onClick={page.nextStep} disabled={!page.shipping_service?.price}>
                Checkout
                {/*<img*/}
                {/*  src="/images/icons/right.svg"*/}
                {/*  alt="shop"*/}
                {/*  className="size-24px"*/}
                {/*/>*/}

              </button>
              {page.error && (
                <p className="tw-w-full text-center" style={{fontSize: '14px', color:'hotpink', fontWeight:'bold',}}>{page.error}</p>
              )}
            </div>
          </div>
        </div>
      </AppContent>

      {/*<Backdrop offset={offset}>*/}
      {/*  <Constraint>*/}
      {/*    <ProductDisplay item={page.item} address={page.address} />*/}
      {/*  </Constraint>*/}
      {/*</Backdrop>*/}



      {/*<Constraint offset={offset}>*/}

      {/*  <Title>Buy this item and get it within 24hrs</Title>*/}

      {/*  <AddressInput*/}
      {/*    name="address"*/}
      {/*    showError={page.hasAddressError}*/}
      {/*    address={page.address}*/}
      {/*    onChange={page.addressSaved}*/}
      {/*    placeholder="Your street address"*/}
      {/*    flat={!page.showShippingSelection}*/}
      {/*  />*/}
      {/*  {!page.showShippingSelection ? (*/}
      {/*    <Button*/}
      {/*      flat={!page.showShippingSelection}*/}
      {/*      disabled={!page.address.hasAddress}*/}
      {/*      onClick={page.showShippingOptions}>*/}
      {/*      See shipping options*/}
      {/*    </Button>*/}
      {/*  ) : (*/}
      {/*    <>*/}
      {/*      <Address2Input*/}
      {/*        type="text"*/}
      {/*        name="address2"*/}
      {/*        id="address2"*/}
      {/*        value={page.address.address2 || ''}*/}
      {/*        onChange={page.address.setAddress2}*/}
      {/*        placeholder="Apt/suite (optional)"*/}
      {/*      />*/}

      {/*      <ShippingSelector*/}
      {/*        state={page.shippingSelector}*/}
      {/*        alias={page.alias}*/}
      {/*        destination={page.address}*/}
      {/*        onChange={page.setShippingService}*/}
      {/*      />*/}
      {/*      {page.shipping_service && <EstimateNote>* post-shipping estimations</EstimateNote>}*/}

      {/*      {UserCountry === 'NG' || page.address.country === 'NG' && (*/}
      {/*        <>*/}
      {/*          <p>&nbsp;</p>*/}
      {/*          <Spring*/}
      {/*            native*/}
      {/*            from={page.from || { opacity: 0, transform: 'translate3d(0,-2rem,0)' }}*/}
      {/*            to={page.to || { opacity: 1, transform: 'translate3d(0,0rem,0)' }}*/}
      {/*            config={page.config || { tension: 150 }}>*/}
      {/*            {animation => (*/}
      {/*              <animated.div style={animation}>*/}
      {/*                <Title>{'Apply bonus'}</Title>*/}
      {/*                <AvForm>*/}
      {/*                  <Label>*/}
      {/*                    <Input*/}
      {/*                      name="discountCode"*/}
      {/*                      type="text"*/}
      {/*                      placeholder="Enter discount code"*/}
      {/*                      value={page.discount_code}*/}
      {/*                      onChange={(evt) => { page.setDiscountCode(evt.target.value); }}*/}
      {/*                    />*/}
      {/*                    <ApplyCode onClick={verifyCode} type="submit" />*/}
      {/*                  </Label>*/}
      {/*                </AvForm>*/}
      {/*              </animated.div>*/}
      {/*            )}*/}
      {/*          </Spring>*/}
      {/*          {page.discount_data_message ? (*/}
      {/*            <p style={{fontSize:'12px', textAlign:'end'}}>{page.discount_data_message}</p>*/}
      {/*          ):''}*/}
      {/*          <ToPay><strong>You will pay</strong> {getPayAmount()}</ToPay>*/}
      {/*        </>*/}
      {/*      )}*/}

      {/*      <ProgressRow>*/}
      {/*        <ContinueButton delay={0} onClick={page.nextStep} />*/}
      {/*      </ProgressRow>*/}
      {/*    </>*/}
      {/*  )}*/}
      {/*</Constraint>*/}
    </>

    return (
      returnStep
    );
  }),
);
